











































import { defineComponent } from '@vue/composition-api';
import { Quiz } from '../state';

export default defineComponent({
  name: 'Quiz',
  props: {
    questions: { type: Array as () => Quiz },
    version: Number,
    currentQuestion: Number,
    selectedOption: Number,
    score: Number,
  },
  setup(props, { emit }) {
    return {
      prev: () => {
        emit('quiz:prev');
      },

      next: () => {
        emit('quiz:next');
      },

      restart: () => {
        emit('quiz:restart');
      },

      select: (index: number) => {
        emit('quiz:select', index);
      },
    };
  },
});
